<template>
  <div>
    <v-card>
      <ConfirmSubjectMarkDialog
        :state="confirmMarkDialog"
        :importedDocuments="importedDocuments"
        @closeDialog="closeConfirmDialog"
        @updateResult="onUpdateResultDocument"
        ref="markDialog"
      />
      <div class="pa-6">
        <div class="full-width text-end">
          <v-menu open-on-hover bottom offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="mt-0 mb-6" color="green" dark v-bind="attrs" v-on="on" outlined> Nhập/xuất Excel </v-btn>
            </template>

            <v-list>
              <v-list-item class="cursor-pointer">
                <v-list-item-title @click="onUploadClick">Tải lên tệp Excel chứa điểm</v-list-item-title>
                <input
                  ref="uploader"
                  type="file"
                  class="d-none"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  @change="onFileChanged"
                />
              </v-list-item>
              <v-list-item class="cursor-pointer">
                <v-list-item-title @click="exportDataToExcel">Tải xuống tệp Excel mẫu</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        <div class="d-flex justify-between align-center pb-6" style="width: 100%">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="saveMarks" :loading="loading">Lưu</v-btn>
        </div>

        <v-card outlined>
          <v-data-table
            item-key="id"
            :headers="headers"
            :loading="loading"
            :items="marks"
            :items-per-page="-1"
            :disable-sort="$vuetify.breakpoint.smAndDown"
            hide-default-footer
            v-bind="this.$attrs"
            fixed-header
          >
            <template v-slot:[`item.examCode`]="{ item }">
              {{ item.examCode || '-' }}
            </template>
            <template v-slot:[`item.value`]="{ item }">
              <v-text-field hide-details outlined dense v-model="item.value" @input="formatInput(item)" />
            </template>
          </v-data-table>
        </v-card>
        <div class="d-flex justify-end align-center pt-6">
          <v-btn color="primary" @click="saveMarks" :loading="loading">Lưu</v-btn>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { ExamMark } from '@/plugins/api'
import readXlsxFile from 'read-excel-file'
import moment from 'moment'
import XLSX from 'xlsx-js-style'
import ConfirmSubjectMarkDialog from './ConfirmSubjectMarkDialog.vue'

const originHeaders = [
  {
    text: 'Học sinh',
    value: 'student.name',
    align: 'left',
    sortable: false,
    show: true,
    width: '25%'
  },
  {
    text: 'Lớp',
    value: 'student.data.studentClass',
    align: 'left',
    sortable: false,
    show: true,
    width: '25%'
  },
  {
    text: 'SBD',
    value: 'examCode',
    align: 'left',
    sortable: false,
    show: true,
    width: '25%'
  },
  {
    text: 'Điểm',
    value: 'value',
    align: 'left',
    sortable: false,
    show: false,
    width: '25%'
  }
]
const schema = {
  'Học sinh': {
    prop: 'student',
    type: String
  },
  Lớp: {
    prop: 'class',
    type: String
  },
  SBD: {
    prop: 'examCode',
    type: String
  },
  Điểm: {
    prop: 'value',
    type: String
  }
}
export default {
  props: {
    query: Object,
    subject: Object,
    exam: Object,
    fileName: String
  },
  data() {
    return {
      loading: false,
      headers: originHeaders,
      marks: [],
      item: {},
      importedDocuments: [],
      confirmMarkDialog: false,
      json_fields: {
        STT: 'index',
        'Học sinh': 'student.name',
        Lớp: 'student.data.studentClass',
        SBD: 'examCode',
        Điểm: 'value'
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['user'])
  },
  methods: {
    ...mapActions('examMark', ['fetchMarks', 'countMarks']),
    async refresh() {
      this.$loading.active = true
      this.loading = true
      try {
        const fetchedMarks = await this.fetchMarks({
          ...this.query,
          status: 'present',
          _sort: 'examCode:ASC',
          _limit: -1
        })
        this.marks = fetchedMarks
      } catch (error) {
        this.$alert.error('Lỗi load thông tin học sinh')
      } finally {
        this.loading = false
        this.$loading.active = false
      }
    },
    async formatInput(item) {
      let input = item.value.toString().replace(/\D/g, '')

      if (/^10+$/.test(input)) {
        const zeroCount = input.length - 2
        item.value = `10.${'0'.repeat(zeroCount > 0 ? zeroCount : 1)}`
      } else if (input.length === 1) {
        item.value = input
      } else if (input.length >= 2) {
        item.value = `${input[0]}.${input.slice(1)}`
      }
    },
    async saveMarks() {
      this.$loading.active = true
      this.loading = true
      try {
        await ExamMark.updateSubjectGrades({
          marks: this.marks,
          subject: this.subject._id,
          exam: this.exam._id
        })
        this.$alert.success('Nhập điểm thành công')
      } catch (e) {
        this.$alert.error(e)
      } finally {
        this.loading = false
        this.$loading.active = false
        this.refresh()
      }
    },
    onUploadClick() {
      this.isSelecting = true
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false
        },
        { once: true }
      )
      this.$refs.uploader.click()
    },
    async onFileChanged(e) {
      this.$loading.active = true
      this.selectedFile = e.target.files[0]
      let readFileResult
      try {
        readFileResult = await readXlsxFile(this.selectedFile, {
          schema,
          transformData(rows) {
            return rows.slice(4, -7)
          }
        })
      } catch (error) {
        console.error(error)
        this.$alert.error('File không có định dạng .xlsx hoặc có dữ liệu không hợp lệ (tham khảo mẫu file)')
        this.$loading.active = false
        return
      }
      this.$alert.success('Đã đọc File thành công!')
      if (readFileResult.errors.length !== 0) {
        const error = readFileResult.errors[0]
        this.$alert.error(`Lỗi Dòng ${error.row} - Cột ${error.column} - ${error.value}: ${error.error}`)
        this.$loading.active = false
        return
      } else {
        const data = readFileResult.rows
        this.importedDocuments = data
        this.confirmMarkDialog = true
      }
      this.$loading.active = false
    },
    formatDataForExport(data) {
      return data.map((item, index) => {
        let formattedItem = {}
        for (let key in this.json_fields) {
          const fieldPath = this.json_fields[key]
          let value = item

          if (typeof fieldPath === 'string') {
            const pathParts = fieldPath.split('.')
            pathParts.forEach(part => {
              value = value ? value[part] : ''
            })
          }

          formattedItem[key] = value !== undefined && value !== null ? value : ''
          // Add the STT value based on the index
          if (key === 'STT') {
            value = index + 1 // STT starts from 1
            formattedItem[key] = { v: value, t: 's' }
          }
        }
        return formattedItem
      })
    },
    async onUpdateResultDocument(data) {
      this.$refs.uploader.value = null
      const updateData = {
        marks: data,
        exam: this.exam._id,
        subject: this.subject._id
      }
      await ExamMark.updateSubjectGrades(updateData)
      this.closeConfirmDialog()
      this.refresh()
    },
    closeConfirmDialog() {
      this.confirmMarkDialog = false
      this.$refs.uploader.value = null
    },
    exportDataToExcel() {
      const formattedData = this.formatDataForExport(this.marks)
      const worksheet = XLSX.utils.json_to_sheet([], { skipHeader: true })
      const headers = [
        ['Trường THPT Lý Thái Tổ', ''],
        [`PHIẾU ĐIỂM ${this.exam.name.toUpperCase()}`, ''],
        [`Môn: ${this.subject.name}`, ''],
        [``, '']
      ]
      const signatureRow = formattedData.length + 7
      // Signature area
      worksheet[`E${signatureRow}`] = worksheet[`E${signatureRow}`] || {}
      worksheet[`E${signatureRow}`].v = 'Cán bộ chấm kiểm tra'
      worksheet[`E${signatureRow}`].t = 's'
      worksheet[`E${signatureRow}`].s = {
        font: { sz: 12, name: 'Arial', bold: true },
        alignment: { horizontal: 'center', vertical: 'center', wrapText: true }
      }
      worksheet[`E${signatureRow + 1}`] = worksheet[`E${signatureRow + 1}`] || {}
      worksheet[`E${signatureRow + 1}`].v = '(Ký, ghi rõ họ và tên)'
      worksheet[`E${signatureRow + 1}`].t = 's'
      worksheet[`E${signatureRow + 1}`].s = {
        font: { sz: 12, name: 'Arial' },
        alignment: { horizontal: 'center', vertical: 'center', wrapText: true }
      }

      worksheet[`E${signatureRow + 5}`] = worksheet[`E${signatureRow + 5}`] || {}
      worksheet[`E${signatureRow + 5}`].v = `${this.user.name ? this.user.name : ''}`
      worksheet[`E${signatureRow + 5}`].t = 's'
      worksheet[`E${signatureRow + 5}`].s = {
        font: { sz: 12, name: 'Arial', bold: true },
        alignment: { horizontal: 'center', vertical: 'center', wrapText: true }
      }

      headers.forEach((header, rowIndex) => {
        const cellAddress = `A${rowIndex + 1}`
        worksheet[cellAddress] = { v: header[0], t: 's' }

        if (rowIndex === 0 || rowIndex === 2 || rowIndex === 3) {
          worksheet[cellAddress].s = {
            font: { bold: true, sz: 13, name: 'Times New Roman' },
            alignment: { horizontal: 'left', vertical: 'center' }
          }
        }

        if (rowIndex === 1) {
          worksheet[cellAddress].s = {
            font: { bold: true, sz: 16, name: 'Times New Roman' },
            alignment: { horizontal: 'center', vertical: 'center' }
          }
        }
      })

      // Define merges for the headers
      worksheet['!merges'] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: 4 } },
        { s: { r: 1, c: 0 }, e: { r: 1, c: 4 } },
        { s: { r: 2, c: 0 }, e: { r: 2, c: 4 } },
        { s: { r: 3, c: 0 }, e: { r: 3, c: 4 } }
      ]
      // Set column widths for columns
      worksheet['!cols'] = [
        { wch: 10 }, // Column A width
        { wch: 20 }, // Column B width
        { wch: 20 }, // Column C width
        { wch: 20 }, // Column D width
        { wch: 20 } // Column E width
      ]
      // Define common styles for headers and data cells
      const headerStyle = {
        font: { bold: true, sz: 12, name: 'Times New Roman' },
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'thin' },
          bottom: { style: 'thin' },
          left: { style: 'thin' },
          right: { style: 'thin' }
        }
      }

      const dataStyle = {
        font: { sz: 12, name: 'Times New Roman' },
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'thin' },
          bottom: { style: 'thin' },
          left: { style: 'thin' },
          right: { style: 'thin' }
        }
      }

      // Add the actual table data starting from A5
      XLSX.utils.sheet_add_json(worksheet, formattedData, {
        origin: 'A5',
        header: this.getHeaders(),
        skipHeader: false
      })

      this.getHeaders().forEach((header, colIndex) => {
        const colLetter = String.fromCharCode(65 + colIndex) // Convert column index to letter (A, B, C, ...)
        const headerCellAddress = `${colLetter}5`

        // Ensure the header cell exists before applying styles
        if (worksheet[headerCellAddress]) {
          worksheet[headerCellAddress].s = headerStyle // Apply header style
        }

        // Apply data style to each data row only if data is available
        if (formattedData.length > 0) {
          for (let rowIndex = 6; rowIndex < formattedData.length + 6; rowIndex++) {
            const dataCellAddress = `${colLetter}${rowIndex}`

            // Ensure the data cell exists before applying styles
            if (worksheet[dataCellAddress]) {
              worksheet[dataCellAddress].s = dataStyle
            }
          }
        }
      })

      // If there is no data, apply the border to just the first row after headers
      if (formattedData.length === 0) {
        this.getHeaders().forEach((header, colIndex) => {
          const colLetter = String.fromCharCode(65 + colIndex) // Convert column index to letter (A, B, C, ...)
          const dataCellAddress = `${colLetter}6`

          worksheet[dataCellAddress] = { v: '', t: 's' }
          worksheet[dataCellAddress].s = headerStyle // Apply header style to the first row after headers
        })
      }

      const endRow = signatureRow + 6
      worksheet['!ref'] = `A1:E${endRow}`
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Điểm')
      XLSX.writeFile(workbook, `${this.exam.name}_${this.subject.name}.xlsx`)
      this.$loading.active = false
    },
    getHeaders() {
      const headers = []
      for (let key in this.json_fields) {
        headers.push(key)
      }
      return headers
    }
  },
  watch: {
    query: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.refresh()
        }
      }
    }
  },
  filters: {
    getDate: item => {
      if (item) return moment(item).format('DD/MM/YYYY')
      return ''
    }
  },
  components: { ConfirmSubjectMarkDialog }
}
</script>
